import { isError } from "../type-checking/type-checking.es.js";
function parseErrorMessage(error) {
  return `${isError(error) ? error.message : error}`;
}
export {
  parseErrorMessage
};
//# sourceMappingURL=parsing.es.js.map
